/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type WindowTypeEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const WindowTypeEnum = {
    NUMBER_1: 1 as WindowTypeEnum,
    NUMBER_2: 2 as WindowTypeEnum,
    NUMBER_3: 3 as WindowTypeEnum,
    NUMBER_4: 4 as WindowTypeEnum,
    NUMBER_5: 5 as WindowTypeEnum,
    NUMBER_6: 6 as WindowTypeEnum,
    NUMBER_7: 7 as WindowTypeEnum
};

